import React from 'react';
import { Skeleton } from '../skeleton/index.js';
import styled, { css } from 'styled-components';
import { SYS_SIZE_FIXED_400, SYS_SIZE_FIXED_500, SYS_SIZE_FIXED_600, SYS_SIZE_FIXED_300 } from '@oneaudi/unified-web-common';
const StyledTextSkeleton = styled(Skeleton) `
  width: ${(props) => props.width ?? '100%'};

  ${(props) => props.emphasis === 'normal'
    ? css `
          height: ${props.order === '1'
        ? props.heights[600]
        : props.order === '2'
            ? props.heights[500]
            : props.heights[400]};
        `
    : css `
          height: ${props.order === '1'
        ? props.heights[500]
        : props.order === '2'
            ? props.heights[400]
            : props.heights[300]};
        `}
`;
export const TextSkeleton = ({ order, emphasis = 'normal', width, margin, lines, 'data-testid': dataTestId, className }) => {
    const getHeight = (size) => `${parseInt(size) * (lines || 1)}px`;
    const heights = {
        600: getHeight(SYS_SIZE_FIXED_600),
        500: getHeight(SYS_SIZE_FIXED_500),
        400: getHeight(SYS_SIZE_FIXED_400),
        300: getHeight(SYS_SIZE_FIXED_300)
    };
    return (React.createElement(StyledTextSkeleton, { heights: heights, "data-testid": dataTestId, variant: "rectangular", order: order, emphasis: emphasis, width: width, margin: margin, className: className }));
};
//# sourceMappingURL=index.skeleton.js.map